import React from 'react';
import { useProviders } from '../../../queries/ats/me/providers/hooks';
import { AtsLinkItemProps } from './ats-item.interfaces';
import { SvodExternalLink } from './svod-external-link';
import { ThirdPartyExternalLink } from './third-party-external-link';

export const ExternalLinkItem = React.forwardRef<HTMLAnchorElement, AtsLinkItemProps>(
  ({ item, children, ...rest }, ref) => {
    const { data: providers, isLoading } = useProviders();

    if (isLoading) {
      return (
        <a {...rest} ref={ref}>
          {children}
        </a>
      );
    }

    if (providers === undefined) {
      throw new Error('Failed to load providers.');
    }

    const provider = providers.find((p) => p.id === item.params.providerIdentifier);

    if (provider === undefined) {
      throw new Error(`Failed to find provider with id "${item.params.providerIdentifier}".`);
    }

    switch (provider.type) {
      case 'svod':
        return <SvodExternalLink {...rest} item={item} provider={provider} children={children} ref={ref} {...rest} />;
      case 'thirdParty':
        return (
          <ThirdPartyExternalLink {...rest} item={item} provider={provider} children={children} ref={ref} {...rest} />
        );
      default:
        return null;
    }
  },
);
